import React, { forwardRef, useContext } from 'react';
import { StyledArrow } from './styled';
import PopperStylesContext from '../popover/context';
export const Arrow = forwardRef((props, ref) => {
    const styles = useContext(PopperStylesContext);
    return React.createElement(StyledArrow, { "data-popper-arrow": true, ref: ref, style: styles === null || styles === void 0 ? void 0 : styles.arrow, ...props });
});
Arrow.displayName = 'Arrow';
